module.exports = __webpack_public_path__ + "static/media/phone-banner.46eb6ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/phone-banner.png
// module id = 687
// module chunks = 0